import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { Table } from "react-bootstrap";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import FuseLoading from "../../../../components/FuseLoading";
import DeleteModal from "../../../../components/DeletePopUpComponent";



const PrQuestionMaster = () => {


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("PR Question Master"))
  }, [])
  const initialFormData = {
    Title: "",
    selectedOption: null,
    Weightage: "",
    Active: 1,
    MinCharacter: null,
    MaxCharacter: null,
    Option1: "",
    Option2: "",
    Option3: "",
    Option4: "",
    Option5: "",
    OptionWeightage1: "",
    OptionWeightage2: "",
    OptionWeightage3: "",
    OptionWeightage4: "",
    OptionWeightage5: "",
    GroupID:"",
    QuestionType_202: "",
  };
  // new area
  const [PRQues, setPRQues] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [questionTypeOptions, setQuestionTypeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [errors, setErrors] = useState({});
  console.log("errors:::", errors);

  const [inputDisabled, setInputDisabled] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [selectedCategoryOption, setSelectedCategoryOption] = useState(null);
  const [prQueID, setPrQueId] = useState("");
  const [apiStatus, setApiStatus] = useState("");
  const [pageLoading, setPageLaoding] = useState(false);

  const columns = {
    Title: { text: "Title", align: "start", visible: true },
    QuestionType: { text: "Type", align: "center", visible: true },
    Weightage: { text: "Max. Scores", align: "center", visible: true },
    Active: { text: "Active", align: "center", visible: true },
    GroupName: { text: "Cat. Name", align: "center", visible: true },
    CreatedByName: { text: "Created By", align: "left", visible: true },
  };


  useEffect(() => {
    fetchPRQues();
    setApiStatus("");
    setPRQues([])
  }, []);

  useEffect(() => {
  if (prQueID && categoryOptions.length && questionTypeOptions.length) {
    fetchPRQuesID(prQueID);
  }
}, [prQueID, categoryOptions, questionTypeOptions]);

  const fetchPRQues = async () => {
    // setPageLaoding(true)
    try {
      const response = await GetServiceCaller(`${API_URL}question-master`);
      if (response?.status == 200) {

        const data = response?.data?.data?.questions;

        const Status = response;
        setApiStatus(Status?.data?.status);
        setPRQues(data);
        setPrQueId("");
        //option
        const options = response?.data?.data?.questions_type?.map((item) => ({
          value: item?.value,
          label: item?.text,
        }));
        setQuestionTypeOptions(options);
        // Category Questions
        const categoryOptions = response?.data?.data?.mappingcategory?.map((item) => ({
          value: item?.value,
          label: item?.text,
        }));
        console.log("Category",categoryOptions);
        
        setCategoryOptions(categoryOptions);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    } finally {
      setPageLaoding(false)

    }
  };


  const fetchPRQuesID = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}question-master/${id}`);

      if (response.status === 200) {
        const quesData = response?.data?.data;

        if (quesData) {
          const {
            Title,
            Weightage,
            MinCharacter,
            MaxCharacter,
            Option1,
            Option2,
            ID,
            Option3,
            Option4,
            Option5,
            OptionWeightage1,
            OptionWeightage2,
            OptionWeightage3,
            OptionWeightage4,
            OptionWeightage5,
            GroupID,
            QuestionType_202,
            Active,
          } = quesData;

          const selectedOption = questionTypeOptions?.find(
            (option) => option?.value === formData.QuestionType_202
          );
          const categoryOption = categoryOptions.find(
        opt => Number(opt.value) === Number(GroupID)
      );
      setSelectedCategoryOption(categoryOption || null);
          // Update form data with fetched values
          setFormData({
            Title: Title || "",
            ID: ID,
            Weightage: Weightage || "",
            MinCharacter: MinCharacter || null,
            MaxCharacter: MaxCharacter || null,
            Option1: Option1 || "",
            Option2: Option2 || "",
            Option3: Option3 || "",
            Option4: Option4 || "",
            Option5: Option5 || "",
            OptionWeightage1: OptionWeightage1 || "",
            OptionWeightage2: OptionWeightage2 || "",
            OptionWeightage3: OptionWeightage3 || "",
            OptionWeightage4: OptionWeightage4 || "",
            OptionWeightage5: OptionWeightage5 || "",
            GroupID: GroupID||"",
            QuestionType_202: QuestionType_202 || "",
            selectedOption: selectedOption || null,
            Active: Active || 0,
          });
        } else {
          console.error("PR Ques Master not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch PR Ques Master details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PR Ques Master details:", error);
    }
  };


  const handleEdit = async (id) => {
    setShowModal(true);
    setPrQueId(id.ID);
  };

  const handleView = async (id) => {
    setShowModal(true);
    setPrQueId(id.ID);
    setInputDisabled(true);
    setShowSubmitButton(false);
  };

  const handleMCQChange = (name, value) => {
    const updatedValue = value
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: updatedValue };

      // Validate the field if it exists in the schema
      if (schema.fields[name]) {
        schema.validateAt(name, updatedData)
          .then(() => setErrors((prev) => ({ ...prev, [name]: "" })))
          .catch((err) => setErrors((prev) => ({ ...prev, [name]: err.message })));
      }

      return updatedData;
    });
  };


  const resetFormState = () => {
    setFormData({
      Title: "",
      selectedOption: null,
      Weightage: "",
      Active: 1,
      MinCharacter: "",
      MaxCharacter: "",
      Option1: "",
      Option2: "",
      Option3: "",
      Option4: "",
      Option5: "",
      OptionWeightage1: "",
      OptionWeightage2: "",
      OptionWeightage3: "",
      OptionWeightage4: "",
      OptionWeightage5: "",
      QuestionType_202: "",
      GroupID: "", 
    });
    setErrors({});
    setSelectedCategoryOption(null);
    setInputDisabled(false);
    setShowSubmitButton(true);
  };

  const handleEditModalClose = () => {
    setShowModal(false);
    setPrQueId("");
    resetFormState();
  };

  const handleAddForm = () => {
    setShowModal(true);
    resetFormState();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      // Validate the entire form data
      // Validate the entire form data
      await schema.validate(formData, { abortEarly: false });
      setErrors({});
      const url = formData.ID
        ? `${API_URL}question-master/${formData.ID}`
        : `${API_URL}question-master`;
      const method = formData.ID ? "put" : "post";


      const sendData = { ...formData, selectedOption: formData.QuestionType_202 }
      const response = await PostServiceCaller(url, sendData, method);

      if (response.status === 200) {
        resetFormState();
        toast.success(
          formData.ID
            ? "PR Questions updated successfully!"
            : "PR Questions submitted successfully!"
        );
        // setShowModal(false);
        setTimeout(() => {
          fetchPRQues();
        }, 2000)
        

        setShowModal(false)
        setApiStatus("");
      } else {
        console.error(`Failed to submit data. Status: ${response.status}`);
        toast.error("An error occurred while submitting the data.");
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      // toast.error(
      //   formData.ID
      //     ? "Failed to update PR Questions"
      //     : "PR Questions Not Submitted"
      // );

      if (error instanceof Yup.ValidationError) {
        setErrors(
          error.inner.reduce(
            (acc, err) => ({ ...acc, [err.path]: err.message }),
            {}
          )
        );
      }
    } finally {
      setLoading(false);
    }
  };
  const schema = Yup.object().shape({
    Title: Yup.string().required("Title is required"),

    QuestionType_202: Yup.number()
      .typeError("Type is required")
      .required("Type is required"),

    GroupID: Yup.number()
      .typeError("GroupID is required")
      .required("GroupID is required"),

    Weightage: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .when("QuestionType_202", {
        is: (val) => val === null || val === 1342, // ✅ Correct way to check multiple values
        then: (schema) => schema.required("Weightage is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    Active: Yup.number(),

    MinCharacter: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .when("QuestionType_202", {
        is: 1342,
        then: (schema) => schema.required("Min Character is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    MaxCharacter: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .when("QuestionType_202", {
        is: 1342,
        then: (schema) => schema.required("Max Character is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    Option1: Yup.string()
      .when("QuestionType_202", {
        is: (val) => [1343, 1347].includes(val),
        then: (schema) => schema.required("Option 1 is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    Option2: Yup.string()
      .when("QuestionType_202", {
        is: (val) => [1343, 1347].includes(val),
        then: (schema) => schema.required("Option 2 is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    Option3: Yup.string()
      .when("QuestionType_202", {
        is: (val) => [1343, 1347].includes(val),
        then: (schema) => schema.required("Option 3 is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    // Option4: Yup.string()
    //   .when("QuestionType_202", {
    //     is: (val) => [1343, 1347].includes(val),
    //     then: (schema) => schema.required("Option 4 is required"),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),

    OptionWeightage1: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .when("QuestionType_202", {
        is: (val) => [1343, 1347].includes(val),
        then: (schema) => schema.required("Option 1 weightage is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    OptionWeightage2: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .when("QuestionType_202", {
        is: (val) => [1343, 1347].includes(val),
        then: (schema) => schema.required("Option 2 weightage is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    OptionWeightage3: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .when("QuestionType_202", {
        is: (val) => [1343, 1347].includes(val),
        then: (schema) => schema.required("Option 3 weightage is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    // OptionWeightage4: Yup.number()
    //   .transform((value, originalValue) =>
    //     originalValue === "" ? undefined : value
    //   )
    //   .when("QuestionType_202", {
    //     is: (val) => [1343, 1347].includes(val),
    //     then: (schema) => schema.required("Option 4 weightage is required"),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),
  });



  const validateField = async (name, value) => {
    try {
      await schema.validateAt(name, { ...formData, [name]: value });
      setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error for the field
    } catch (err) {
      setErrors((prev) => ({ ...prev, [name]: err.message })); // Set error message
    }
  };

  // Handle dropdown or input change
  const handleChange = async (e) => {
    const { name, type, checked, value } = e.target;
    console.log("name,value", name, value);

    // For checkbox, use checked value, otherwise use the normal value
    const updatedValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    // Update form data only for fields in the schema
    if (schema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: updatedValue };
        // Trigger validation for the specific field after updating formData
        validateField(name, updatedValue);
        return updatedData;
      });
    }
  };


 const handleSelect = (selectedOption, name) => {
  setFormData(prev => ({
    ...prev,
    [name]: selectedOption ? selectedOption.value : null
  }));

  if (name === "GroupID") {
    setSelectedCategoryOption(selectedOption);
  }

  validateField(name, selectedOption ? selectedOption.value : null);
};
  const handleDeleteOpen = (item) => {
    setShowDeleteModal(true);
    setSelectedDeleteItem(item);
  };



  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      handleDeleteQuestion(selectedDeleteItem.ID);
    }
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  }



  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  };

  const handleDeleteQuestion = async (queMasterID) => {
    // e.preventDefault();
    setLoading(true);
    try {
      const response = await DeleteServiceCaller(
        `${API_URL}question-master/${queMasterID}`,
        {},
        "delete"
      );
      if (response.status === 200) {
        setShowDeleteModal(false);
        setLoading(false);
        setApiStatus("");
        fetchPRQues();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching skills:", error);
    }
  };





  // if (pageLoading) {
  //   return (
  //     <>
  //       <p class="position-absolute top-50 start-50 translate-middle text-center">
  //         <FaSpinner class="spinner" />
  //       </p>
  //     </>
  //   );
  // } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">

          <div className="container-fluid" id="skill-table-area">
            <div className="row mt-2">
              <Dynamic_PR_table
                data={PRQues}
                columns={columns}
                itemsPerPage={10}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                showIcon2={true}
                showIcon3={true}
                isSorting={false}
                isActionRequired={true}
                isAddNewBtnRequired={true}
                handleAddNew={handleAddForm}
                handleIcon1={handleEdit}
                handleIcon2={handleDeleteOpen}
                handleIcon3={handleView}
                add
                more
                function
                icons={{
                  Icon1: <i className="bi bi-pencil-square icons"></i>,
                  Icon2: <i className="bi bi-trash-fill icons"></i>,
                  Icon2Text: "Delete",
                  Icon2Flag: "CanBeDelete",
                  Icon3: <i className="bi bi-eye-fill icons"></i>,
                  Icon3Text: "View",
                }}
              />
            </div>
          </div>


          {/* Bootstrap Modal */}
          <div>
            {showModal && (
              <div
                className="modal "
                tabIndex="-1"
                role="dialog"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between">
                      <h3 className="heading skill-heading">
                        PR Question Master
                      </h3>
                      <span className="me-2">
                        <i
                          className="bi bi-x-lg"
                          onClick={handleEditModalClose}
                        ></i>
                      </span>
                    </div>
                    <div className="modal-body">
                      <div className="">
                        <form onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label"
                            >
                              Title<span className="required">*</span>
                            </label>
                            <textarea
                              className={`form-control ${errors.Title ? "is-invalid" : ""}`}
                              id="exampleFormControlTextarea1"
                              rows="3"
                              name="Title"
                              value={formData.Title} // Controlled input
                              onChange={handleChange} // Handle input change
                              disabled={inputDisabled} // Disable if inputDisabled is true
                            ></textarea>
                            {errors.Title && (
                              <div className="invalid-feedback">
                                {errors.Title}
                              </div>
                            )}
                          </div>
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label htmlFor="type" className="col-form-label">
                                <strong>Category</strong>
                                <span className="required">*</span>
                              </label>
                              <Select
                                id="type"
                                value={selectedCategoryOption} // Ensure the value matches the selected option object
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                                name="GroupID"
                                isDisabled={inputDisabled}
                                options={categoryOptions}
                                className={`form-control p-0 ${errors.GroupID ? "is-invalid" : ""}`}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                aria-describedby="type"
                              />
                              {errors.GroupID && (
                                <div className="invalid-feedback">
                                  {errors.GroupID}
                                </div>
                              )}
                            </div>
                            <div className="col-md-3 mb-3">
                              <label htmlFor="type" className="col-form-label">
                                <strong>Type</strong>
                                <span className="required">*</span>
                              </label>
                              <Select
                                id="type"
                                value={questionTypeOptions.find(option => option.value === formData.QuestionType_202)} // Ensure the value matches the selected option object
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                                name="QuestionType_202"
                                isDisabled={inputDisabled}
                                options={questionTypeOptions}
                                className={`form-control p-0 ${errors.QuestionType_202 ? "is-invalid" : ""}`}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                aria-describedby="type"
                              />
                              {errors.QuestionType_202 && (
                                <div className="invalid-feedback">
                                  {errors.QuestionType_202}
                                </div>
                              )}
                            </div>
                            <div className="col-md-3 mb-2">
                              <label
                                htmlFor="Weightage"
                                className="col-form-label"
                              >
                                <strong>Max Score</strong>{formData.QuestionType_202 ===
                                  1342 ? <span className="text-danger">*</span> : ""}
                              </label>

                              <input
                                type="number"
                                  onWheel={(e) => e.preventDefault()} // 👈 block wheel input

                                id="Weightage"
                                className={`form-control ${errors.Weightage ? "is-invalid" : ""}`}
                                name="Weightage"
                                value={formData.Weightage || ""} // Ensuring it defaults to an empty string if undefined
                                onChange={(e) => handleChange(e)}
                                disabled={inputDisabled}
                              />
                              {errors.Weightage && (
                                <div className="invalid-feedback">
                                  {errors.Weightage}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-2 d-flex">
                              <label className="form-label">Active</label>
                              <div>
                                <input
                                  className="ms-2 form-check-input"
                                  type="checkbox"
                                  name="Active"
                                  checked={formData.Active === 1} // Ensure that it checks for 1
                                  onChange={handleChange} // Handle checkbox change
                                  disabled={inputDisabled}
                                />
                              </div>
                            </div>
                            <div>
                              {/* Descriptive Section  */}
                              {formData.QuestionType_202 &&
                                formData.QuestionType_202 ===
                                1342 && (
                                  <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="row align-items-center">
                                        <div className="col-4">
                                          <label
                                            htmlFor="MinCharacter"
                                            className="col-form-label"
                                          >
                                            <strong>Min Character</strong><span className="required">*</span>
                                          </label>
                                        </div>
                                        <div className="col-8">
                                          <input
                                            type="number"
                                            id="minCharacter"
                                            name="MinCharacter"
                                            className={`form-control ${errors.MinCharacter ? "is-invalid" : ""}`}
                                            value={formData.MinCharacter || ""}
                                            onChange={(e) =>
                                              handleChange(e)
                                            }
                                            aria-describedby="MinCharacter"
                                            disabled={inputDisabled}
                                          />
                                          {errors.MinCharacter && (
                                            <div className="invalid-feedback">
                                              {errors.MinCharacter}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="row align-items-center">
                                        <div className="col-4">
                                          <label
                                            htmlFor="MaxCharacter"
                                            className="col-form-label"
                                          >
                                            <strong>Max Character</strong><span className="required">*</span>
                                          </label>
                                        </div>
                                        <div className="col-8">
                                          <input
                                            type="number"
                                            // id="MaxCharacter"
                                            name="MaxCharacter"
                                            className={`form-control ${errors.MaxCharacter ? "is-invalid" : ""}`}
                                            value={formData.MaxCharacter}
                                            onChange={(e) =>
                                              handleChange(e)
                                            }
                                            aria-describedby="MaxCharacter"
                                            disabled={inputDisabled}
                                          />
                                          {errors.MaxCharacter && (
                                            <div className="invalid-feedback">
                                              {errors.MaxCharacter}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                            {/* MCQs Section and MSQs Section */}
                            {formData.QuestionType_202 &&
                              (formData.QuestionType_202 === 1343 ||
                                formData.QuestionType_202 === 1347) && (
                                <div className="mt-4">
                                  <Table bordered>
                                    <thead id="thcolor" className="text-center">
                                      <tr>
                                        <th className="col-10 text-start">
                                          Options
                                        </th>
                                        <th className="col-2">Score</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="text"
                                                className={`form-control ${errors.Option1 ? "is-invalid" : ""}`}
                                                placeholder="Option 1"
  onWheel={(e) => e.preventDefault()} // 👈 block wheel input
                                                value={formData.Option1}
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "Option1",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.Option1 && (
                                                <div className="invalid-feedback">{errors.Option1}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="number"
                                                                                  onWheel={(e) => e.preventDefault()} // 👈 block wheel input

                                                className={`form-control ${errors.OptionWeightage1 ? "is-invalid" : ""}`}
                                                value={
                                                  formData.OptionWeightage1
                                                }
                                                name="OptionWeightage1"
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "OptionWeightage1",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.OptionWeightage1 && (
                                                <div className="invalid-feedback">{errors.OptionWeightage1}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="text"
                                                className={`form-control ${errors.Option2 ? "is-invalid" : ""}`}
                                                placeholder="Option 2"
                                                value={formData.Option2}
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "Option2",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.Option2 && (
                                                <div className="invalid-feedback">{errors.Option2}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="number"
                                                                                  onWheel={(e) => e.preventDefault()} // 👈 block wheel input

                                                className={`form-control ${errors.OptionWeightage2 ? "is-invalid" : ""}`}
                                                value={
                                                  formData.OptionWeightage2
                                                }
                                                name="OptionWeightage2"
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "OptionWeightage2",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.OptionWeightage2 && (
                                                <div className="invalid-feedback">{errors.OptionWeightage2}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="text"
                                                className={`form-control ${errors.Option3 ? "is-invalid" : ""}`}
                                                placeholder="Option 3"
                                                value={formData.Option3}
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "Option3",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.Option3 && (
                                                <div className="invalid-feedback">{errors.Option3}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="number"
                                                                                  onWheel={(e) => e.preventDefault()} // 👈 block wheel input

                                                className={`form-control ${errors.OptionWeightage3 ? "is-invalid" : ""}`}
                                                value={
                                                  formData.OptionWeightage3
                                                }
                                                name="OptionWeightage3"
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "OptionWeightage3",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.OptionWeightage3 && (
                                                <div className="invalid-feedback">{errors.OptionWeightage3}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="text"
                                                className={`form-control ${errors.Option4 ? "is-invalid" : ""}`}
                                                placeholder="Option 4"
                                                value={formData.Option4}
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "Option4",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.Option4 && (
                                                <div className="invalid-feedback">{errors.Option4}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="number"
                                                name="OptionWeightage4"
                                                                                  onWheel={(e) => e.preventDefault()} // 👈 block wheel input

                                                className={`form-control ${errors.OptionWeightage4 ? "is-invalid" : ""}`}
                                                value={
                                                  formData.OptionWeightage4
                                                }
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "OptionWeightage4",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                              {errors.OptionWeightage4 && (
                                                <div className="invalid-feedback">{errors.OptionWeightage4}</div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Option 5"
                                                value={formData.Option5}
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "Option5",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="row">
                                            <div className="col-12">
                                              <input
                                                type="number"
                                                                                  onWheel={(e) => e.preventDefault()} // 👈 block wheel input

                                                className="form-control"
                                                value={
                                                  formData.OptionWeightage5
                                                }
                                                name="OptionWeightage5"
                                                onChange={(e) =>
                                                  handleMCQChange(
                                                    "OptionWeightage5",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={inputDisabled}
                                              />
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              )}
                          </div>
                          <div className="text-end">
                            <button
                              className="cancel-btn me-2"
                              onClick={handleEditModalClose}
                            >
                              Cancel
                            </button>
                            {showSubmitButton && (
                              <button
                                type="button"
                                disabled={loading ? true : false}
                                className="custom-btn me-2"
                                onClick={handleSubmit}
                              >
                                {loading ? (
                                  <FaSpinner class="sm-spinner" />
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>



          <DeleteModal
            show={showDeleteModal}
            onClose={handleDeleteClose}
            onConfirm={handleModalDelete}
            message="Are you sure you want to delete this item?"
          />
        </div>
      </>
    );
  }
// }

export default PrQuestionMaster;
